/* CappyRevolution · Kern-Logik (assets/cr.js)
   Warenkorb über die Shopify Ajax API mit Section Rendering (Drawer = sections/cr-cart-drawer.liquid),
   Drawer, Toast, Rails, Reveal und der Patch-Slot für die Live-Vorschau.
   Konfiguration kommt aus window.CR_CFG (layout/theme.liquid). */
(function () {
  'use strict';
  document.documentElement.classList.add('cr-js');
  const CFG = window.CR_CFG || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const CR = (window.CR = window.CR || {});
  Object.assign(CR, { $, $$, cfg: CFG });

  /* ---------- Geld ---------- */
  CR.money = (cents) => {
    const fmt = CFG.moneyFormat || '{{amount_with_comma_separator}} €';
    const v = (cents / 100);
    const de = (n, d) => n.toLocaleString('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d });
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      amount_no_decimals: Math.round(v).toLocaleString('en-US'),
      amount_with_comma_separator: de(v, 2),
      amount_no_decimals_with_comma_separator: de(v, 0),
      amount_with_apostrophe_separator: v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'"),
    }[k] ?? de(v, 2)));
  };

  /* ---------- Toast ---------- */
  let tt;
  CR.toast = (msg, img) => {
    let t = $('.cr-toast');
    if (!t) { t = document.createElement('div'); t.className = 'cr-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = '';
    if (img) { const i = new Image(); i.src = img; i.alt = ''; t.appendChild(i); }
    t.appendChild(document.createTextNode(msg));
    t.classList.add('cr-show'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('cr-show'), 2600);
  };

  /* ---------- Drawer ---------- */
  let lastFocus = null;
  CR.openDrawer = (id) => {
    const d = document.getElementById('cr-drawer-' + id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('cr-open'); d.setAttribute('aria-hidden', 'false'); d.removeAttribute('inert');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => $('[data-cr-close]:not(.cr-drawer__bg)', d)?.focus(), 60);
  };
  CR.closeDrawers = () => {
    $$('.cr-drawer.cr-open').forEach(d => { d.classList.remove('cr-open'); d.setAttribute('aria-hidden', 'true'); d.setAttribute('inert', ''); });
    document.documentElement.style.overflow = '';
    lastFocus?.focus?.();
  };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-cr-open]');
    if (o) { e.preventDefault(); CR.openDrawer(o.dataset.crOpen); return; }
    if (e.target.closest('[data-cr-close]')) { e.preventDefault(); CR.closeDrawers(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') CR.closeDrawers(); });

  /* ---------- Warenkorb ---------- */
  const SECTION = 'cr-cart-drawer';
  const root = () => (CFG.routes?.root || '/').replace(/\/?$/, '/');
  function renderCart(sections, cart) {
    const html = sections?.[SECTION];
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('.cr-drawer__inner');
      const cur = $('#cr-drawer-cart .cr-drawer__inner');
      if (fresh && cur) cur.replaceWith(fresh);
    }
    const count = cart ? cart.item_count : +($('#cr-drawer-cart [data-cr-count]')?.dataset.crCount || 0);
    $$('.cr-cart-count').forEach(e => { e.textContent = count; e.hidden = !count; });
  }
  CR.renderCart = renderCart;
  async function post(url, body) {
    const r = await fetch(root() + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const j = await r.json();
    if (!r.ok || j.status) throw new Error(j.description || j.message || 'Warenkorb-Fehler');
    return j;
  }
  async function refresh() {
    const r = await fetch(root() + '?sections=' + SECTION);
    const sections = await r.json();
    const cart = await (await fetch(root() + 'cart.js')).json();
    renderCart(sections, cart);
    return cart;
  }
  CR.cart = {
    /* items: [{id: variantId, quantity, properties}] */
    async add(items, { toastImg, open = true } = {}) {
      const res = await post('cart/add.js', { items, sections: SECTION });
      const cart = await (await fetch(root() + 'cart.js')).json();
      renderCart(res.sections, cart);
      const cc = $('.cr-cart-count'); if (cc) { cc.classList.remove('cr-bump'); void cc.offsetWidth; cc.classList.add('cr-bump'); }
      CR.toast(items.length > 1 ? `Set mit ${items.length} Artikeln im Warenkorb` : 'Im Warenkorb', toastImg);
      if (open) setTimeout(() => CR.openDrawer('cart'), 350);
      document.dispatchEvent(new CustomEvent('cr:cart', { detail: cart }));
      return cart;
    },
    async change(line, quantity) {
      const res = await post('cart/change.js', { line, quantity, sections: SECTION });
      renderCart(res.sections, res);
      document.dispatchEvent(new CustomEvent('cr:cart', { detail: res }));
      return res;
    },
    refresh,
  };
  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-cr-line]');
    if (q) {
      e.preventDefault();
      const drawer = $('#cr-drawer-cart .cr-drawer__inner'); drawer?.classList.add('cr-busy');
      try { await CR.cart.change(+q.dataset.crLine, +q.dataset.crQty); } catch (err) { CR.toast(err.message); drawer?.classList.remove('cr-busy'); }
      return;
    }
    const u = e.target.closest('[data-cr-upsell]');
    if (u) {
      e.preventDefault(); u.disabled = true;
      try { await CR.cart.add([{ id: +u.dataset.crUpsell, quantity: 1 }], { toastImg: u.querySelector('img')?.src, open: false }); }
      catch (err) { CR.toast(err.message); u.disabled = false; }
    }
  });
  // Zurück-Navigation (bfcache): Zähler aktuell halten
  addEventListener('pageshow', (e) => { if (e.persisted) refresh().catch(() => {}); });

  /* ---------- Rails ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cr-rail]'); if (!b) return;
    const rail = document.getElementById(b.getAttribute('aria-controls')); if (!rail) return;
    rail.scrollBy({ left: +b.dataset.crRail * rail.clientWidth * 0.8, behavior: 'smooth' });
  });

  /* ---------- Merkliste (lokal, nur Komfort) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('.cr-card__wish'); if (!b) return;
    e.preventDefault();
    const on = b.classList.toggle('cr-on'); b.setAttribute('aria-pressed', on);
    try {
      const k = 'cr_wish', s = new Set(JSON.parse(localStorage.getItem(k) || '[]'));
      on ? s.add(b.dataset.handle) : s.delete(b.dataset.handle);
      localStorage.setItem(k, JSON.stringify([...s]));
    } catch (_) {}
  });
  function markWishes() {
    let s; try { s = new Set(JSON.parse(localStorage.getItem('cr_wish') || '[]')); } catch (_) { return; }
    $$('.cr-card__wish').forEach(b => { const on = s.has(b.dataset.handle); b.classList.toggle('cr-on', on); b.setAttribute('aria-pressed', on); });
  }

  /* ---------- Patch-Slot ----------
     box aus Metafeld custom.patch_box, Werte in % des ersten Produktfotos:
     4 Zahlen = Rechteck [left, top, width, height] (frontale Fotos),
     8 Zahlen = Ecken [x,y oben links, oben rechts, unten rechts, unten links] (schräge Fotos, Perspektive per matrix3d). */
  CR.parseBox = (s) => { const a = String(s || '').split(',').map(Number); return (a.length === 4 || a.length === 8) && a.every(n => !isNaN(n)) ? a : null; };
  // Projektive Abbildung des Quadrats 100×100 px auf die vier Ecken (px)
  const quadMatrix = (p) => {
    const [x0, y0, x1, y1, x2, y2, x3, y3] = p;
    const dx1 = x1 - x2, dx2 = x3 - x2, dx3 = x0 - x1 + x2 - x3, dy1 = y1 - y2, dy2 = y3 - y2, dy3 = y0 - y1 + y2 - y3;
    const den = dx1 * dy2 - dx2 * dy1;
    const g = (dx3 * dy2 - dx2 * dy3) / den, h = (dx1 * dy3 - dx3 * dy1) / den;
    const a = x1 - x0 + g * x1, b = x3 - x0 + h * x3, d = y1 - y0 + g * y1, e = y3 - y0 + h * y3;
    return `matrix3d(${a / 100},${d / 100},0,${g / 100},${b / 100},${e / 100},0,${h / 100},0,0,1,0,${x0},${y0},0,1)`;
  };
  CR.slot = (el, box) => {
    if (!box) return;
    if (el._crRO) { el._crRO.disconnect(); el._crRO = null; }
    if (box.length === 4) {
      Object.assign(el.style, { left: box[0] + '%', top: box[1] + '%', width: box[2] + '%', height: box[3] + '%', transform: '', transformOrigin: '' });
      return;
    }
    Object.assign(el.style, { left: '0', top: '0', width: '100px', height: '100px', transformOrigin: '0 0' });
    const host = el.offsetParent || el.parentElement;
    const fit = () => {
      const w = host.clientWidth, h = host.clientHeight;
      if (w && h) el.style.transform = quadMatrix(box.map((v, i) => v / 100 * (i % 2 ? h : w)));
    };
    fit();
    if ('ResizeObserver' in window) { el._crRO = new ResizeObserver(fit); el._crRO.observe(host); }
  };
  CR.swapPatch = (slot, src, rip = true) => {
    const old = $('.cr-slot__patch', slot);
    const n = document.createElement('div'); n.className = 'cr-slot__patch cr-slap';
    const img = new Image(); img.src = src; img.alt = ''; n.appendChild(img);
    if (old && rip) { old.classList.remove('cr-slap'); old.classList.add('cr-rip'); setTimeout(() => old.remove(), 650); }
    else if (old) old.remove();
    slot.appendChild(n);
  };
  /* Shopify-Bild-URL auf Breite bringen */
  CR.img = (url, w) => { if (!url) return ''; try { const u = new URL(url, location.href); u.searchParams.set('width', w); return u.toString(); } catch (_) { return url; } };

  /* ---------- Reveal ---------- */
  CR.reveal = (scope = document) => {
    const els = $$('.cr-rv:not(.cr-in)', scope);
    if (!('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('cr-in')); return; }
    const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('cr-in'); io.unobserve(e.target); } }), { threshold: 0.08 });
    els.forEach(e => { const r = e.getBoundingClientRect(); if (r.top < innerHeight) e.classList.add('cr-in'); else io.observe(e); });
  };

  /* ---------- Header: dunkel über dem Hero ---------- */
  function headerTone() {
    const hdr = $('.cr-hdr'), hero = $('.cr-hero');
    if (!hdr) return;
    if (!hero) { hdr.classList.remove('cr-hdr--dark'); return; }
    const io = new IntersectionObserver(([e]) => hdr.classList.toggle('cr-hdr--dark', e.isIntersecting), { rootMargin: '-70px 0px 0px 0px' });
    io.observe(hero);
  }

  /* ---------- Cookie-Einstellungen (Shopify Customer Privacy) ---------- */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-cr-cookies]')) return;
    e.preventDefault();
    if (window.privacyBanner?.showPreferences) window.privacyBanner.showPreferences();
    else CR.toast('Das Cookie-Banner ist im Shop-Admin noch nicht aktiviert.');
  });

  /* ---------- Announcement-Leiste ---------- */
  let annTimer;
  function announce() {
    clearInterval(annTimer);
    const track = $('.cr-announce__track'); if (!track) return;
    const n = track.children.length; if (n < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let i = 0;
    annTimer = setInterval(() => { i = (i + 1) % n; track.style.transform = `translateY(${-i * 100 / n}%)`; }, 4000);
  }

  function init() { headerTone(); CR.reveal(); markWishes(); announce(); }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  // Theme-Editor: nach dem Neuladen einer Section erneut initialisieren
  document.addEventListener('shopify:section:load', (e) => { CR.reveal(e.target); markWishes(); headerTone(); announce(); });
})();
